<mat-tab-group (selectedIndexChange)="onTabChange($event)">
    <mat-tab label="Search Bank by IFSC">

        <form #g="ngForm" [formGroup]="searchByIfscFormGroup" (ngSubmit)="submitBankForm(searchByIfscFormGroup)"
              (keydown.enter)="$event.preventDefault()">
            <p class="txt1 mt-4" >Bank’s IFSC</p>
            <mat-form-field style="width: 100%">
                <input type="text" matInput (keyup)="bankIfsc($event)" placeholder="Eg : SBIM234567"
                       style="text-transform: uppercase;" autocomplete="off" name="ifsc" maxlength="11"
                       title="Please provide a valid IFSC code" pattern="[a-zA-Z]{4}[a-zA-Z0-9]{7}" required
                       [(ngModel)]="ifsc" formControlName="ifsc" (input)="clearPreFilledDetails()">
                <a mat-button matSuffix class="buttonv" (click)="searchViaIfsc(ifsc)">Search</a>
                <mat-error *ngIf="searchByIfscFormGroup.controls.ifsc.invalid">
                    {{ getErrorMessage(searchByIfscFormGroup.controls.ifsc) }}
                </mat-error>
            </mat-form-field>

            <p class="txt1 mt-4">Bank Name</p>
            <mat-form-field style="width: 100%">
                <input type="text" matInput placeholder="" name="bankName" [readonly]="true" required
                       [(ngModel)]="bankName" formControlName="bankName">
                <mat-error *ngIf="searchByIfscFormGroup.controls.bankName.invalid">
                    {{ getErrorMessage(searchByIfscFormGroup.controls.bankName) }}
                </mat-error>
            </mat-form-field>

            <p class="txt2 mt-4">City</p>
            <mat-form-field style="width: 100%">
                <input type="text" matInput placeholder="" name="city" [readonly]="true" required [(ngModel)]="city"
                       formControlName="city">
                <mat-error *ngIf="searchByIfscFormGroup.controls.city.invalid">
                    {{ getErrorMessage(searchByIfscFormGroup.controls.city) }}
                </mat-error>
            </mat-form-field>

            <p class="txt1 mt-4">Bank Branch</p>
            <mat-form-field style="width: 100%">
                <input type="text" matInput placeholder="" name="branchName" [readonly]="true" required
                       [(ngModel)]="branchName" formControlName="branch">
                <mat-error *ngIf="searchByIfscFormGroup.controls.branch.invalid">
                    {{ getErrorMessage(searchByIfscFormGroup.controls.branch) }}
                </mat-error>
            </mat-form-field>

            <div *ngIf="bankAccountDetails">
                <section>
                    <p class="txt1 mt-4">Your Name as in Bank Account</p>
                    <mat-form-field style="width: 100%">
                        <input type="text" autocomplete="off" maxlength="50" matInput
                               name="accountHolderName" required [(ngModel)]="accountHolderName"
                               placeholder="Account Holder's Name" formControlName="accountHolderName">
                        <mat-error *ngIf="searchByIfscFormGroup.controls.accountHolderName.invalid">
                            {{ getErrorMessage(searchByIfscFormGroup.controls.accountHolderName) }}
                        </mat-error>
                    </mat-form-field>
                </section>

                <p class="txt1 mt-4">Account Type</p>
                <mat-form-field style="width:100%">
                    <mat-select placeholder="Select Account Type" name="accountType" [(ngModel)]="accountType"
                                formControlName="accountType" required>
                        <mat-option *ngFor="let accountType of accountTypes" [value]="accountType.value">
                            {{ accountType.viewValue }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="searchByIfscFormGroup.controls.accountType.invalid">
                        {{ getErrorMessage(searchByIfscFormGroup.controls.accountType) }}
                    </mat-error>
                </mat-form-field>

                <div formGroupName="accountNumberGroup">
                    <p class="txt1 mt-4">Account Number</p>
                    <mat-form-field style="width: 100%">
                        <input type="password" (keyup)="bankAccNum1($event)" autocomplete="off" maxlength="26" matInput
                               placeholder="Eg : 1234567890" name="accountNumber" required [(ngModel)]="accountNumber"
                               oncopy="return false" oncut="return false" onpaste="return false"
                               formControlName="accountNumber">
                        <mat-error *ngIf="searchByIfscFormGroup.get('accountNumberGroup').get('accountNumber').invalid">
                            {{ getErrorMessage(searchByIfscFormGroup.get('accountNumberGroup').get('accountNumber')) }}
                        </mat-error>
                    </mat-form-field>

                    <p class="txt1 mt-4">Confirm Account Number</p>
                    <mat-form-field style="width: 100%">
                        <input type="text" (keyup)="bankAccNum2($event)" autocomplete="off" maxlength="26" matInput
                               formControlName="repeatedAccountNumber" required
                               placeholder="Eg : 1234567890" name="reAccountNumber" [(ngModel)]="reAccountNumber"
                               oncopy="return false" oncut="return false" onpaste="return false">
                        <mat-error *ngIf="searchByIfscFormGroup.get('accountNumberGroup').get('repeatedAccountNumber').invalid">
                            {{ getErrorMessage(searchByIfscFormGroup.get('accountNumberGroup').get('repeatedAccountNumber')) }}
                        </mat-error>
                    </mat-form-field>
                    <small>
                        <mat-error *ngIf="searchByIfscFormGroup.get('accountNumberGroup').hasError('match') &&
                searchByIfscFormGroup.get('accountNumberGroup').get('repeatedAccountNumber').touched" class="small">
                            {{ getErrorMessage(searchByIfscFormGroup.get('accountNumberGroup')) }}
                        </mat-error>
                    </small>

                    <div class="row buttondiv">
                        <div class="col-sm-6 backbtn">
                            <button mat-stroked-button class="button-back primary" type="button" [routerLink]="[backButtonLink]">
                                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
                            </button>
                        </div>
                        <div class="col-sm-6 moveright">
                            <button mat-flat-button class="button-forward primary" type="submit" (click)="onNext.emit()">NEXT &nbsp;&nbsp;&nbsp;<i
                                    class="material-icons">arrow_forward</i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

    </mat-tab>

    <mat-tab label="Search IFSC by Bank">

        <form #d="ngForm" [formGroup]="searchByBankFormGroup" (ngSubmit)="submitBankForm(searchByBankFormGroup)"
              (keydown.enter)="$event.preventDefault()">
            <p class="txt1 mt-4">Bank Name</p>

            <mat-form-field style="width: 100%">
                <input type="text" matInput required [ngModel]="bankName"
                       formControlName="bankName" [matAutocomplete]="bankNames">
                <mat-autocomplete autoActiveFirstOption #bankNames="matAutocomplete">
                    <mat-option *ngFor="let bankName of filteredBankNames | async" [value]="bankName"
                                (onSelectionChange)="onBankNameSelected(bankName)">
                        {{ bankName }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="searchByBankFormGroup.controls.bankName.invalid">
                    {{ getErrorMessage(searchByBankFormGroup.controls.bankName) }}
                </mat-error>
            </mat-form-field>

            <p class="txt2 mt-4">City</p>

            <mat-form-field style="width: 100%">
                <input type="text" matInput required [readonly]="cityreadonly" (ngModelChange)="getCityName()"
                       [ngModel]="city" name="city" formControlName="city" [matAutocomplete]="cities">
                <mat-autocomplete autoActiveFirstOption #cities="matAutocomplete">
                    <mat-option *ngFor="let city of filteredCities | async" [value]="city"
                                (onSelectionChange)="onCitySelected(city)">
                        {{ city }}
                    </mat-option>
                </mat-autocomplete>
                <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingCities"></mat-spinner>
                <mat-error *ngIf="searchByBankFormGroup.controls.city.invalid">{{
                    getErrorMessage(searchByBankFormGroup.controls.city) }}
                </mat-error>
            </mat-form-field>

            <p class="txt1 mt-4">Bank Branch</p>

            <mat-form-field style="width: 100%">
                <input type="text" matInput required [readonly]="branchreadonly"
                       [ngModel]="branchName" name="branchName" formControlName="branch"
                       [matAutocomplete]="branches">
                <mat-autocomplete autoActiveFirstOption #branches="matAutocomplete">
                    <mat-option *ngFor="let branchName of filteredBranches | async" [value]="branchName"
                                (onSelectionChange)="onBranchSelected(branchName)">
                        {{ branchName }}
                    </mat-option>
                </mat-autocomplete>
                <mat-spinner [diameter]="35" class="mat-spinner" matSuffix *ngIf="loadingBranches"></mat-spinner>
                <mat-error *ngIf="searchByBankFormGroup.controls.branch.invalid">{{
                    getErrorMessage(searchByBankFormGroup.controls.branch) }}
                </mat-error>
            </mat-form-field>

            <p class="txt1 mt-4">Bank’s IFSC</p>
            <mat-form-field style="width: 100%">
                <input type="text" matInput placeholder="Eg : SBIM234567" readonly="true"
                       style="text-transform: uppercase;" autocomplete="off" name="ifsc" maxlength="11"
                       formControlName="ifsc"
                       required [(ngModel)]="ifsc">
                <mat-error *ngIf="searchByBankFormGroup.controls.ifsc.invalid">{{
                    getErrorMessage(searchByBankFormGroup.controls.ifsc) }}
                </mat-error>
            </mat-form-field>

            <div *ngIf="bankAccountDetails">
                <p class="txt1 mt-4">Your Name as in Bank Account</p>
                <mat-form-field style="width: 100%">
                    <input type="text" autocomplete="off" maxlength="50" matInput
                           formControlName="accountHolderName" name="accountHolderName"
                           placeholder="Account Holder's Name" required [(ngModel)]="accountHolderName">
                    <mat-error *ngIf="searchByBankFormGroup.controls.accountHolderName.invalid">
                        {{ getErrorMessage(searchByBankFormGroup.controls.accountHolderName) }}
                    </mat-error>
                </mat-form-field>

                <p class="txt1 mt-4">Account Type</p>
                <mat-form-field style="width:100%">
                    <mat-select placeholder="Select Account Type" name="accountType" [(ngModel)]="accountType"
                                formControlName="accountType" required>
                        <mat-option *ngFor="let accountType of accountTypes" [value]="accountType.value">
                            {{ accountType.viewValue }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="searchByBankFormGroup.controls.accountType.invalid">
                        {{ getErrorMessage(searchByBankFormGroup.controls.accountType) }}
                    </mat-error>
                </mat-form-field>

                <div formGroupName="accountNumberGroup">
                    <p class="txt1 mt-4">Account Number</p>
                    <mat-form-field style="width: 100%">
                        <input type="password" (keyup)="bankAccNum1($event)" autocomplete="off" maxlength="26" matInput
                               placeholder="Eg : 1234567890" name="accountNumber" required [(ngModel)]="accountNumber"
                               oncopy="return false" oncut="return false" onpaste="return false"
                               formControlName="accountNumber">
                        <mat-error *ngIf="searchByBankFormGroup.get('accountNumberGroup').get('accountNumber').invalid">
                            {{ getErrorMessage(searchByBankFormGroup.get('accountNumberGroup').get('accountNumber')) }}
                        </mat-error>
                    </mat-form-field>

                    <p class="txt1 mt-4">Confirm Account Number</p>
                    <mat-form-field style="width: 100%">
                        <input type="text" (keyup)="bankAccNum2($event)" autocomplete="off" maxlength="26" matInput
                               formControlName="repeatedAccountNumber" required
                               placeholder="Eg : 1234567890" name="reAccountNumber" [(ngModel)]="reAccountNumber"
                               oncopy="return false" oncut="return false" onpaste="return false">
                        <mat-error *ngIf="searchByBankFormGroup.get('accountNumberGroup').get('repeatedAccountNumber').invalid">
                            {{ getErrorMessage(searchByBankFormGroup.get('accountNumberGroup').get('repeatedAccountNumber')) }}
                        </mat-error>
                    </mat-form-field>
                    <small>
                        <mat-error *ngIf="searchByBankFormGroup.get('accountNumberGroup').hasError('match') &&
                searchByBankFormGroup.get('accountNumberGroup').get('repeatedAccountNumber').touched" class="small">
                            {{ getErrorMessage(searchByBankFormGroup.get('accountNumberGroup')) }}
                        </mat-error>
                    </small>
                </div>
            </div>

            <div class="row buttondiv">
                <div class="col-sm-6 backbtn">
                    <button mat-stroked-button class="button-back primary" type="button" [routerLink]="[backButtonLink]">
                        <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;
                        BACK
                    </button>
                </div>
                <div class="col-sm-6 moveright">
                    <app-forward-button class="button-forward" (click)="onNext.emit()">NEXT</app-forward-button>
                </div>
            </div>

        </form>
    </mat-tab>
</mat-tab-group>
